import React from 'react';

export function BetInput({
  homeValue,
  awayValue,
  onHomeChange,
  onAwayChange,
  disabled,
  homeLabel = 'Home',
  awayLabel = 'Away',
  idPrefix = 'bet',
  isRTL = false
}) {
  return (
    <div
      dir={isRTL ? 'rtl' : 'ltr'}
      className="grid w-full grid-cols-[1fr_auto_1fr] items-end gap-2 sm:gap-3"
    >
      <div>
        <label
          htmlFor={`${idPrefix}-home`}
          className="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500"
        >
          {homeLabel}
        </label>
        <input
          id={`${idPrefix}-home`}
          type="number"
          inputMode="numeric"
          min={0}
          disabled={disabled}
          value={homeValue}
          onChange={(e) => onHomeChange(e.target.value)}
          className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 text-center text-lg font-semibold text-slate-900 transition placeholder:text-slate-400 focus:border-brand-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand-500/20 disabled:cursor-not-allowed disabled:opacity-60"
        />
      </div>
      <span className="pb-3 text-lg font-bold text-slate-300" aria-hidden>
        :
      </span>
      <div>
        <label
          htmlFor={`${idPrefix}-away`}
          className="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500"
        >
          {awayLabel}
        </label>
        <input
          id={`${idPrefix}-away`}
          type="number"
          inputMode="numeric"
          min={0}
          disabled={disabled}
          value={awayValue}
          onChange={(e) => onAwayChange(e.target.value)}
          className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 text-center text-lg font-semibold text-slate-900 transition placeholder:text-slate-400 focus:border-brand-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand-500/20 disabled:cursor-not-allowed disabled:opacity-60"
        />
      </div>
    </div>
  );
}
